module.exports = __webpack_public_path__ + "static/media/mobile.1bcf1aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/mobile.png
// module id = 268
// module chunks = 0